import cx from 'classnames';
import React from 'react';
import { ConditionalView } from '../../utils/ConditionalView';
import IconButton from '../IconButton/IconButton';
import RadioButton from '../RadioButton/RadioButton';
import styles from './RadioButtonItem.module.scss';
import usePresenter from './RadioButtonItem.presenter';
import type { RadioButtonItemProps } from './RadioButtonItem.types';

const RadioButtonItem = React.forwardRef<HTMLInputElement, RadioButtonItemProps>((props: RadioButtonItemProps, ref) => {
  const {
    handleChange,
    variantProps,
    isSelected,
    defaultChecked,
    value,
    disabled,
    invalid,
    required,
    labelAlignment,
    children,
    showRightButton,
    onRightButtonClick,
    rightButtonIcon,
    otherProps,
  } = usePresenter(props);

  return (
    <div
      className={cx(
        styles.radioButtonItem,
        props.className,
        {
          [styles.disabled]: disabled,
          [styles.hasRightButton]: showRightButton,
        },
      )}
      {...variantProps}
    >
      <RadioButton
        checked={isSelected}
        defaultChecked={defaultChecked}
        onChange={handleChange}
        disabled={disabled}
        invalid={invalid}
        required={required}
        labelAlignment={labelAlignment}
        ref={ref}
        value={value}
        {...otherProps}
      >
        {children}
      </RadioButton>
      <ConditionalView condition={showRightButton}>
        <IconButton
          className={styles.rightButton}
          onClick={onRightButtonClick}
          disabled={disabled}
          appearance="Default"
          size="Small"
          style="Secondary"
          icon={rightButtonIcon}
          type="Ghost"
          actionType="button"
        />
      </ConditionalView>
    </div>
  );
});

export default RadioButtonItem; 